import { render } from "./transferlist.vue?vue&type=template&id=c0fe7cda"
import script from "./transferlist.vue?vue&type=script&lang=js"
export * from "./transferlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__